<template>
  <header class="header"
          ref="headerleads">
    <ApisCreationModal data-entity="apis"
                       @registered="emitNewApiRegistered" />

    <button class="btn btn-primary btn-extra-round"
            @click="openApiDocs">
      {{$t('message.api.message.documentation')}}
    </button>
  </header>
</template>

<script>
    import ApisCreationModal from '@views/apis/components/ApisCreationModal'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
          ApisCreationModal
        },

        computed: {

        },

        mounted(){

        },

        methods: {
          emitNewApiRegistered() {
            EventBus.$emit('API_REGISTERED');
          },
          openApiDocs() {
            window.open('https://wifeedapi.docs.apiary.io/#', '_blank')
          }
        },
    }
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
</style>
